import { createSlice } from '@reduxjs/toolkit';

const editRoomDetailsPopup = createSlice({
  name: 'editRoomDetailsPopup',
  initialState: {
    data: null,
  },
  reducers: {
    show: (state, { payload }) => {
      state.data = payload
    },
    close: (state) => {
      state.data = null;
    },
  },
});

export const editRoomDetailsPopupActions = editRoomDetailsPopup.actions;
export const editRoomDetailsPopupReducer = editRoomDetailsPopup.reducer;
export default editRoomDetailsPopupReducer;

export const selectEditRoomDetailsPopupData = (state) => state.editRoomDetailsPopup.data